"use client";
import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Notification } from "@nxt-costco-com/forge-components";
import { CheckmarkCircle } from "@nxt-costco-com/forge-icons/icons/CheckmarkCircle";
import { Info } from "@nxt-costco-com/forge-icons/icons/Info";
import { notificationContainerStyles, notificationContentStyles } from "./styles.js";
const NotificationsUI = ({
  type,
  message
}) => {
  return /* @__PURE__ */ jsx(
    Box,
    {
      id: "save-to-list-drawer-notification",
      sx: notificationContainerStyles,
      children: type === "success" ? /* @__PURE__ */ jsx(
        Notification,
        {
          icon: /* @__PURE__ */ jsx(CheckmarkCircle, { "aria-label": "Checkmark-Circle" }),
          message,
          severity: "success",
          sx: notificationContentStyles
        }
      ) : /* @__PURE__ */ jsx(
        Notification,
        {
          icon: /* @__PURE__ */ jsx(Info, { "aria-label": "Alert" }),
          message,
          severity: "critical",
          sx: notificationContentStyles
        }
      )
    }
  );
};
export {
  NotificationsUI
};
